export const COMPANY = {
  name: "BeltingBD",
  parent: "L&P Industrial Automation Ltd.",
  mainSite: "https://laneeka.com/",
  agency: "Guangdong Boshun Belting Co., Ltd.",
  established: 2011,
  phone: "+8801819-850278",
  phoneRaw: "+8801819850278",
  whatsapp: "https://wa.me/8801819850278",
  email: "contact@beltingbd.com",
  address: "House #5 (Ground Floor), Road #4, Nikunja-2, Khilkhet, Dhaka-1229, Bangladesh",
  hours: "Saturday – Thursday, 9:00 AM – 6:00 PM",
};

export const IMAGES = {
  heroFactory:
    "https://images.unsplash.com/photo-1701328778019-e95dedbf5346?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxjb252ZXlvciUyMGJlbHQlMjBmYWN0b3J5JTIwaW5kdXN0cmlhbCUyMG1hY2hpbmVyeXxlbnwwfHx8fDE3ODk0MTQzMzR8MA&ixlib=rb-4.1.0&q=85",
  curvedConveyor:
    "https://images.unsplash.com/photo-1717386255893-59c0846cdef0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwyfHxjb252ZXlvciUyMGJlbHQlMjBmYWN0b3J5JTIwaW5kdXN0cmlhbCUyMG1hY2hpbmVyeXxlbnwwfHx8fDE3ODk0MTQzMzR8MA&ixlib=rb-4.1.0&q=85",
  steelAssembly:
    "https://images.unsplash.com/photo-1589792924333-edbfbe7c8be7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwzfHxjb252ZXlvciUyMGJlbHQlMjBmYWN0b3J5JTIwaW5kdXN0cmlhbCUyMG1hY2hpbmVyeXxlbnwwfHx8fDE3ODk0MTQzMzR8MA&ixlib=rb-4.1.0&q=85",
  verticalConveyor:
    "https://images.unsplash.com/photo-1651615832931-1f0540d43ef0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHw0fHxjb252ZXlvciUyMGJlbHQlMjBmYWN0b3J5JTIwaW5kdXN0cmlhbCUyMG1hY2hpbmVyeXxlbnwwfHx8fDE3ODk0MTQzMzR8MA&ixlib=rb-4.1.0&q=85",
  roboticsConveyor:
    "https://images.unsplash.com/photo-1716191299980-a6e8827ba10b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwzfHxpbmR1c3RyaWFsJTIwbWFudWZhY3R1cmluZyUyMGF1dG9tYXRlZCUyMGNvbnZleW9yJTIwc3lzdGVtfGVufDB8fHx8MTc4OTQxNDM0Mnww&ixlib=rb-4.1.0&q=85",
  automatedLine:
    "https://images.unsplash.com/photo-1647427060118-4911c9821b82?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxpbmR1c3RyaWFsJTIwbWFudWZhY3R1cmluZyUyMGF1dG9tYXRlZCUyMGNvbnZleW9yJTIwc3lzdGVtfGVufDB8fHx8MTc4OTQxNDM0Mnww&ixlib=rb-4.1.0&q=85",
  largeFacility:
    "https://images.unsplash.com/photo-1717386255773-1e3037c81788?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxpbmR1c3RyaWFsJTIwbWFudWZhY3R1cmluZyUyMGF1dG9tYXRlZCUyMGNvbnZleW9yJTIwc3lzdGVtfGVufDB8fHx8MTc4OTQxNDM0Mnww&ixlib=rb-4.1.0&q=85",
  gearPrecision:
    "https://images.unsplash.com/photo-1524514587686-e2909d726e9b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHxzdGVlbCUyMG1hY2hpbmVyeSUyMGZhY3RvcnklMjBlbmdpbmVlcmluZyUyMGdlYXJ8ZW58MHx8fHwxNzg5NDE0MzQyfDA&ixlib=rb-4.1.0&q=85",
};

export const PRODUCTS = [
  {
    id: "pvc-conveyor-belts",
    name: "PVC Conveyor Belts",
    category: "Conveyor Belts",
    blurb: "General-purpose workhorse for light to medium duty conveying across packaging, logistics and assembly lines.",
    image: "/belts/pvc-conveyor-belt.png",
    specs: {
      Material: "Polyvinyl chloride, fabric-reinforced",
      "Temp Range": "-10°C to +80°C",
      Thickness: "1.0 – 6.0 mm",
      "Max Width": "Up to 2000 mm",
      Applications: "Packaging, sorting, assembly lines",
    },
  },
  {
    id: "pu-conveyor-belts",
    name: "PU Conveyor Belts",
    category: "Conveyor Belts",
    blurb: "Food-grade polyurethane belts with superior oil, fat and abrasion resistance for hygienic production.",
    image: "/belts/pu-conveyor-belt.webp",
    specs: {
      Material: "Thermoplastic polyurethane (TPU)",
      "Temp Range": "-20°C to +80°C",
      Thickness: "0.8 – 4.0 mm",
      Compliance: "FDA / EU food contact grades",
      Applications: "Food processing, pharma, bakeries",
    },
  },
  {
    id: "cotton-canvas-belts",
    name: "Cotton Canvas Belts",
    category: "Conveyor Belts",
    blurb: "Traditional woven canvas belts for dough handling, textile and low-temperature bulk conveying.",
    image: "/belts/cotton-canvas-belt.webp",
    specs: {
      Material: "Woven cotton canvas plies",
      "Temp Range": "-10°C to +70°C",
      Thickness: "3.0 – 8.0 mm",
      Surface: "Natural grip, breathable",
      Applications: "Bakeries, textile mills, agriculture",
    },
  },
  {
    id: "plastic-modular-belts",
    name: "Plastic Modular Belts",
    category: "Specialty Systems",
    blurb: "Interlocking acetal/PP modules for curves, inclines and washdown lines — zero tracking issues.",
    image: "/belts/plastic-modular-belt.jpg",
    specs: {
      Material: "POM / PP / PE modules",
      "Temp Range": "-40°C to +104°C",
      Pitch: "12.7 – 50.8 mm",
      Drive: "Positive sprocket drive",
      Applications: "Food washdown, bottling, curves",
    },
  },
  {
    id: "felt-belts",
    name: "Felt Belts",
    category: "Specialty Systems",
    blurb: "Dense needle-punched felt for cut-resistant, soft-touch conveying of delicate or hot products.",
    image: "/belts/felt-belt.webp",
    specs: {
      Material: "Needle-punched synthetic felt",
      "Temp Range": "-10°C to +120°C",
      Thickness: "2.5 – 8.0 mm",
      Surface: "Soft, non-marking, cut-resistant",
      Applications: "Glass, tiles, aluminium extrusion",
    },
  },
  {
    id: "stainless-steel-mesh-belts",
    name: "Stainless Steel Mesh Belts",
    category: "Specialty Systems",
    blurb: "Open-wire stainless mesh for ovens, fryers, cooling tunnels and extreme-temperature processes.",
    image: "/belts/ss-mesh-conveyor-belt.webp",
    specs: {
      Material: "SS304 / SS316 woven wire",
      "Temp Range": "Up to +600°C",
      Weave: "Balanced / compound / chain-driven",
      "Open Area": "Up to 85% for airflow",
      Applications: "Baking, frying, heat treatment",
    },
  },
  {
    id: "teflon-ptfe-belts",
    name: "Teflon / PTFE Seamless Belts",
    category: "Specialty Systems",
    blurb: "Non-stick PTFE-coated seamless belts for fusing, laminating and high-heat release applications.",
    image: "/belts/teflon-ptfe-belt.webp",
    specs: {
      Material: "PTFE-coated fibreglass, seamless",
      "Temp Range": "-70°C to +260°C",
      Thickness: "0.25 – 1.0 mm",
      Property: "Non-stick, chemical inert",
      Applications: "Garment fusing, laminating, drying",
    },
  },
  {
    id: "tabletop-slat-chains",
    name: "Plastic Tabletop Slat Chains",
    category: "Chains & Curves",
    blurb: "Straight-running and side-flexing slat chains for bottling, canning and accumulation conveyors.",
    image: "/belts/tabletop-slat-chain.webp",
    specs: {
      Material: "POM / stainless steel options",
      Widths: "82.6 – 304.8 mm",
      "Side-flex Radius": "From 500 mm",
      Speed: "Up to 80 m/min lubricated",
      Applications: "Beverage, bottling, dairy lines",
    },
  },
  {
    id: "u-turn-curved-belts",
    name: "U-turn Curved Conveyor Belts",
    category: "Chains & Curves",
    blurb: "Precision-engineered 30°–180° curved belt systems that keep product orientation through turns.",
    image: "/belts/curved-conveyor-belt.jpg",
    specs: {
      Angles: "30° / 45° / 90° / 180°",
      "Belt Type": "Knife-edge PU / modular",
      "Inner Radius": "From 400 mm",
      Drive: "Tapered roller positive drive",
      Applications: "Space-saving line layouts",
    },
  },
];

export const CHAPTERS = [
  {
    num: "01",
    title: "The Mission",
    body: "Since 2011, L&P Industrial Automation Ltd. has kept Bangladesh's factories moving. BeltingBD carries that legacy forward — one obsession: the right belt, spliced to perfection, delivered on time. We are committed to excellence, and we measure it in uptime.",
  },
  {
    num: "02",
    title: "Engineering & Splicing",
    body: "Every belt that leaves our floor is cut, welded or vulcanised to specification. Endless splicing, cleats, sidewalls, guides and perforations — fabricated in-house by technicians who treat a joint like a load-bearing structure. Because it is one.",
  },
  {
    num: "03",
    title: "The Boshun Supply Chain",
    body: "As the exclusive Bangladesh agent of Guangdong Boshun Belting Co., Ltd., we hold genuine factory stock — not grey-market substitutes. Certified compounds, consistent batches, and a direct line from the manufacturer to your plant floor.",
  },
  {
    num: "04",
    title: "Logistics Without Friction",
    body: "Expedited nationwide shipping, route-optimised deliveries and careful handling of every consignment. From Dhaka to Chattogram to the furthest EPZ — your belt arrives ready to run, with installation support on call.",
  },
];

export const INDUSTRIES = [
  { name: "Garments & Textile", note: "Fusing, spreading & finishing lines" },
  { name: "Food Processing", note: "FDA-grade PU & mesh belts" },
  { name: "Packaging", note: "High-speed sorting & sealing" },
  { name: "Pharmaceuticals", note: "Hygienic washdown systems" },
  { name: "Airport & Cargo", note: "Baggage & freight handling" },
  { name: "Heavy Engineering", note: "High-temp steel mesh lines" },
];
